import { __extends } from "tslib";
import { ErrorBase } from '../errors/ErrorBase';
import { ConflictStrategyBase } from './ConflictStrategyBase';
var ErrorConflictStrategy = /** @class */ (function (_super) {
    __extends(ErrorConflictStrategy, _super);
    function ErrorConflictStrategy() {
        return _super.call(this) || this;
    }
    ErrorConflictStrategy.prototype.resolveConflict = function (changedAsset, oldAsset, assetsDictionary, precedence) {
        throw new ErrorBase('Asset name collision while AssetLibrary.namingStrategy ' +
            'set to AssetLibrary.THROW_ERROR. Asset path: ' + changedAsset.adaptee.assetNamespace + '.' + changedAsset.adaptee.name);
    };
    ErrorConflictStrategy.prototype.create = function () {
        return new ErrorConflictStrategy();
    };
    return ErrorConflictStrategy;
}(ConflictStrategyBase));
export { ErrorConflictStrategy };
